/**
 * @desc 查看锁定库存明细
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(
  params: API.stock.stockOrder.pageListStockOrderDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stock/order/detail/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
